<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up white--text"></v-toolbar-side-icon>
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ productMarkupId }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="clickMenu(item.title)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="headline font-weight-medium text-center pl-3 pt-3">
              {{ name }}
              <v-icon class="ml-1" @click="openEditProductMarkupDialog(name)">edit</v-icon>
            </div>
            <div v-if="updatedDateTime" class="body-2 pl-3 pr-3 grey--text">Last updated: {{ updatedDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}</div>
            <div v-else class="body-2 pl-3 pr-3 grey--text">Created: {{ createdDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}</div>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="cboCurrencyCode"
              :rules="[v => !!v || 'Please choose currency']"
              :items="currencies"
              item-text="currencyCode"
              item-value="currencyCode"
              label="Currency"
              @change="changeCurrency($event)"
              required
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div style="overflow-x:scroll;">
              <v-radio-group v-model="wholesaleQtyIndex" :mandatory="false">
                <table border="0" cellspacing="0" cellpadding="0">
                  <tr class="grey darken-2 white--text">
                    <td class="subheading text-xs-center font-weight-bold pa-2" style="min-width:80px;" width="80">
                    </td>
                    <td v-for="(range, rangeIndex) in markups" :key="rangeIndex" class="grey darken-2 pa-2" style="min-width:220px;" width="100">
                      <div v-if="rangeIndex >= markups.length-1" class="subheading text-xs-center font-weight-bold">
                        <span v-if="markups.length === 1">All price range</span>
                        <span v-else>Others</span>
                      </div>
                      <div v-else class="text-xs-center">
                        <v-text-field
                          v-model="markups[rangeIndex].maxCostPrice"
                          @focus="$event.target.select()"
                          label="Price range"
                          type="number"
                          append-outer-icon="cancel"
                          @click:append-outer="removePriceRange(rangeIndex)"
                          :suffix="cboCurrencyCode"
                          solo
                          dark
                          hide-details
                          full-width
                          required
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="pa-2" style="min-width:80px;" width="80">
                      <v-btn block depressed dark v-if="markups.length <= 10" @click="appendPriceRange">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr class="grey darken-1 white--text">
                    <td class="subheading text-xs-center font-weight-bold pa-2" style="min-width:80px;">
                      <v-btn color="grey" small block @click="recountProductInRange">
                        Recount
                      </v-btn>
                    </td>
                    <td v-for="(range, rangeIndex) in markups" :key="rangeIndex" class="grey darken-1 pa-2" style="min-width:120px;">
                      <router-link :to="'/products/?productMarkupId=' + productMarkupId + '&costPriceMin=' + (rangeIndex === 0 ? 0.01 : markups[rangeIndex-1].maxCostPrice) + '&costPriceMax=' + range.maxCostPrice" class="white--text" target="_blank">
                        <div class="body-1 text-xs-center">
                          {{ range.productCount }} SKUs in this range
                        </div>
                      </router-link>
                    </td>
                    <td class="pa-2" style="min-width:80px;">
                    </td>
                  </tr>
                  <tr class="grey darken-2 white--text">
                    <td class="subheading text-xs-center font-weight-bold pa-2">
                    </td>
                    <td v-for="(range, rangeIndex) in markups" :key="rangeIndex" class="grey darken-2 pa-2">
                      <v-layout fluid wrap>
                        <v-flex xs6 class="text-xs-center caption grey--text text--lighten-2">
                          MARKUP %
                        </v-flex>
                        <v-flex xs6 class="text-xs-center caption grey--text text--lighten-2">
                          MIN MARKUP
                        </v-flex>
                      </v-layout>
                    </td>
                    <td class="pa-2" style="min-width:80px;">
                    </td>
                  </tr>
                  <tr v-for="(qty, qtyIndex) in markups[0].markups" :key="qtyIndex">
                    <td class="pa-2">
                      <v-text-field
                        v-if="markups[0].markups.length > 1"
                        v-model="markups[0].markups[qtyIndex].qty"
                        @focus="$event.target.select()"
                        label="Qty"
                        type="number"
                        solo
                        prepend-icon="cancel"
                        @click:prepend="removeQtyRange(qtyIndex)"
                        hide-details
                        required
                      ></v-text-field>
                      <v-text-field
                        v-else
                        v-model="markups[0].markups[qtyIndex].qty"
                        @focus="$event.target.select()"
                        label="Qty"
                        type="number"
                        solo
                        hide-details
                        required
                      ></v-text-field>
                    </td>
                    <td v-for="(range, rangeIndex) in markups" :key="rangeIndex" :class="'pa-2 ' + (rangeIndex % 2 === 0 ? 'row1' : 'row2')">
                      <v-layout fluid wrap>
                        <v-flex xs6 class="text-xs-center">
                          <v-text-field
                            v-model="markups[rangeIndex].markups[qtyIndex].markupPercentage"
                            @focus="$event.target.select()"
                            label="Markup %"
                            type="number"
                            suffix="%"
                            solo
                            hide-details
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center">
                          <v-text-field
                            v-model="markups[rangeIndex].markups[qtyIndex].minimumMarkupAmount"
                            @focus="$event.target.select()"
                            label="Min Markup"
                            type="number"
                            solo
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </td>
                    <td class="pa-2">
                      <v-radio
                        color="primary"
                        label="Wholesale"
                        :value="qtyIndex"
                        class="mt-2"
                      ></v-radio>
                    </td>
                  </tr>
                  <tr>
                    <td class="pa-2">
                      <v-btn block outline v-if="markups[0].markups.length <= 10" @click="appendQtyRange">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </td>
                    <td :colspan="markups.length + 1" class="text-xs-left">
                      <v-btn outline @click="openInsertRangeDialog">
                        Insert Range
                      </v-btn>
                      <v-btn outline @click="openInsertQtyDialog">
                        Insert Qty
                      </v-btn>
                    </td>
                  </tr>
                </table>
              </v-radio-group>
            </div>
          </v-flex>
          <v-flex sm6 xs12>
            <v-btn block large color="primary" @click="saveProductMarkup()">
              Save
            </v-btn>
          </v-flex>
          <!-- <v-flex xs12 sm6>
            <v-btn block large outline @click="productListItems=[]; searchProductDialog = !searchProductDialog; getProducts();">
              Assign to products
            </v-btn>
          </v-flex> -->
        </v-layout>
      </v-container>
      <v-dialog v-model="dialogInsertRange" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Insert Range
          </v-card-title>
          <v-card-text>
            <v-form ref="frmInsertRange" v-model="frmInsertRangeValid" @submit.prevent="">
              <v-select
                v-model="cboInsertRange"
                :items="markups"
                item-text="maxCostPrice"
                item-value="maxCostPrice"
                label="Insert before"
                :rules="[v => !!v || 'Range is required']"
                @keyup.enter="insertPriceRange(cboInsertRange); dialogInsertRange = false"
              ></v-select>
              <v-btn
                :disabled="!frmInsertRangeValid"
                @click="insertPriceRange(cboInsertRange); dialogInsertRange = false"
              >
                Insert
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogInsertQty" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Insert Qty
          </v-card-title>
          <v-card-text>
            <v-form ref="frmInsertQty" v-model="frmInsertQtyValid" @submit.prevent="">
              <v-select
                v-model="cboInsertQty"
                :items="markups[0].markups"
                item-text="qty"
                item-value="qty"
                label="Insert before"
                :rules="[v => !!v || 'Qty is required']"
                @keyup.enter="insertQtyRange(cboInsertQty)"
              ></v-select>
              <v-btn
                :disabled="!frmInsertQtyValid"
                @click="insertQtyRange(cboInsertQty)"
              >
                Insert
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditProductMarkup" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Edit Markup Name
          </v-card-title>
          <v-card-text>
            <v-form ref="frmEditProductMarkup" v-model="frmEditProductMarkupValid" @submit.prevent="">
              <v-text-field
                label="Name"
                v-model="txtProductMarkupNewName"
                :rules="[v => !!v || 'Name is required', v => (v && v.length >= 3) || 'Name must be 3 characters or more']"
                @keyup.enter="editProductMarkup(txtProductMarkupNewName)"
                required
              ></v-text-field>
              <v-btn
                :disabled="!frmEditProductMarkupValid"
                @click="editProductMarkup(txtProductMarkupNewName)"
              >
                Save
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteProductMarkup" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to delete this markup?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogDeleteProductMarkup = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogDeleteProductMarkup = false; deleteProductMarkup();"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="searchProductDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Assign to products</h3>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-flex xs5 sm5>
                <v-text-field
                  label="Search for"
                  v-model="txtProductName"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 sm6>
                <v-select
                  :items="categories"
                  item-text="name"
                  item-value="categoryId"
                  label="Category"
                  v-model="cboProductCategory"
                  @change="getProducts(cboProductCategory, txtProductName)"
                ></v-select>
              </v-flex>
              <v-flex xs2 sm1>
                <v-btn
                  icon
                  @click="getProducts(cboProductCategory, txtProductName)"
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <div style="height:400px;overflow:scroll;border:1px solid #999999;">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6 sm4 md3 v-for="(item, index) in productListItems" :key="index">
                  <v-checkbox
                    class="mt-0 mb-0"
                    color="primary"
                    v-model="item.chk"
                    label=""
                  ></v-checkbox>
                  <v-img :src="item.images[0].smallUrl" class="mb-2 mt-0" />
                  <a :href="'/product/' + item.productId" style="color:#333333;" target="_blank">{{ item.name }}</a>
                  <!--<v-tooltip bottom offset-overflow :max-width=250>
                    <div slot="activator">{{ item.name | truncate(50) }}</div>
                    <span>{{ item.name }}</span>
                  </v-tooltip>-->
                  <div class="headline font-weight-bold mt-3">${{ formatPrice(item.retailPrice) }}</div>
                  <div class="caption font-weight-light">As low as <strong>${{ formatPrice(item.lowestPrice) }}</strong></div>
                  <div v-if="item.productMarkupName" class="caption font-weight-light">Markup: <span class="font-weight-bold">{{ item.productMarkupName }}</span></div>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-flex sm6>
                <v-container fluid grid-list-lg class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-checkbox
                        class="mt-2"
                        color="primary"
                        label="Check all"
                        v-model="chkAllProducts"
                        @change="updateProductsCheckbox(chkAllProducts)"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs8>
                      <v-btn
                        block
                        outline
                        @click="assignMarkupToProducts()"
                      >
                        Assign markup
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex sm3>
                <v-btn
                  block
                  outline
                  :disabled="productListOffset <= 0"
                  @click="getProducts(cboProductCategory, txtProductName, '', (productListOffset-productListLimit <= 0 ? 0 : productListOffset-productListLimit))"
                >
                  Prev
                </v-btn>
              </v-flex>
              <v-flex sm3>
                <v-btn
                  block
                  outline
                  :disabled="productListOffset + productListLimit >= productListTotal"
                  @click="getProducts(cboProductCategory, txtProductName, '', productListOffset+productListLimit)"
                >
                  Next
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
}

::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: rgba(0,0,0,0.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'

export default {
  props: [
    'productMarkupId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      menuItems: [
        { title: 'Delete' }
      ],
      name: '',
      remarks: '',
      wholesaleQtyIndex: null,
      products: [],
      markups: [{
        maxCostPrice: 0,
        productCount: 0,
        markups: [{
          qty: 1,
          markupPercentage: 0,
          minimumMarkupAmount: 0
        }]
      }],
      updatedDateTime: '',
      createdDateTime: '',
      currencies: [],
      cboCurrencyCode: this.$store.getters.getProfile.storeCurrencyCode,
      currencySign: this.$store.getters.getProfile.storeCurrencySign,
      currencyDecimals: this.$store.getters.getProfile.storeCurrencyDecimals,
      currencyDecimalSign: this.$store.getters.getProfile.storeCurrencyDecimalSign,
      dialogInsertRange: false,
      frmInsertRangeValid: false,
      cboInsertRange: 0,
      dialogInsertQty: false,
      frmInsertQtyValid: false,
      cboInsertQty: 0,
      txtProductMarkupName: '',
      frmEditProductMarkupValid: false,
      txtProductMarkupNewName: '',
      dialogEditProductMarkup: false,
      dialogDeleteProductMarkup: false,
      searchProductDialog: false,
      categories: [],
      cboProductCategory: '',
      txtProductName: '',
      chkAllProducts: false,
      productListItems: [],
      productListLimit: 10,
      productListOffset: 0,
      productListTotal: 0
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.getProductMarkup()
    this.getCurrencies()
    // this.getCategories()
    this.disableBottomDetector()
  },
  methods: {
    clickMenu: function (menuTitle) {
      switch (menuTitle) {
        case 'Delete':
          this.openDeleteProductMarkupDialog()
          break
      }
    },
    updateProductsCheckbox: function (chkStatus) {
      for (var i in this.productListItems) {
        this.productListItems[i].chk = chkStatus
      }
    },
    assignMarkupToProducts: function () {
      var productIds = []
      for (var i in this.productListItems) {
        if (this.productListItems[i].chk === true) {
          productIds.push(this.productListItems[i].productId)
        }
      }

      if (productIds.length > 0) {
        // assign markup to products
        var _this = this
        var promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + _this.productMarkupId + '/assign', {
            productIds: productIds
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                window.alert('Markup assigned to products')
                _this.getProducts(_this.cboProductCategory, _this.txtProductName, '', _this.productListOffset)
              } else {
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      } else {
        window.alert('Please select products')
      }
    },
    getCurrencies: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            this.currencies = []
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === this.profile.storeCurrencyCode || resp.data.data[i].currencyCode === this.def.currency.currencyCode) {
                this.currencies.push(resp.data.data[i])
              }
            }
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getCategories: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var categories = [
              {
                name: 'All',
                categoryId: ''
              }
            ]
            var result = this.generateCategoryListRecursive(resp.data.data, categories, 0)
            this.categories = this.categories.concat(result)
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    },
    getProducts: function (categoryId = '', name = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/products?category_id=' + categoryId + '&name=' + encodeURIComponent(name) + '&sort=' + sort + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              resp.data.data.chk = false
              _this.productListItems = resp.data.data
              _this.productListLimit = resp.data.limit
              _this.productListOffset = resp.data.offset
              _this.productListTotal = resp.data.total
            } else {
              console.log('unable to load products: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })

      return promise
    },
    getProductMarkup: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + _this.productMarkupId)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.name = resp.data.data.name
              _this.remarks = resp.data.data.remarks
              _this.updatedDateTime = resp.data.data.updatedDateTime
              _this.createdDateTime = resp.data.data.createdDateTime
              _this.cboCurrencyCode = resp.data.data.currencyCode
              _this.currencyDecimalSign = resp.data.data.currencyDecimalSign
              _this.currencyDecimals = resp.data.data.currencyDecimals
              _this.currencySign = resp.data.data.currencySign
              _this.products = resp.data.data.products
              if (resp.data.data.markups.length > 0) {
                _this.markups = resp.data.data.markups
              } else {
                // initialise markup range
                _this.markups = []
                _this.markups.push({
                  maxCostPrice: 999999999,
                  markups: [{
                    qty: 1,
                    markupPercentage: 0,
                    minimumMarkupAmount: 0
                  }]
                })
              }
              var isFound = false
              for (var i = 0; i < _this.markups[0].markups.length; i++) {
                if (_this.markups[0].markups[i].qty === resp.data.data.wholesaleQtyLevel) {
                  _this.wholesaleQtyIndex = i
                  isFound = true
                  break
                }
              }
              if (isFound === false) {
                // assign the last qty index as wholesale
                _this.wholesaleQtyIndex = _this.markups[0].markups.length - 1
              }
            } else {
              console.log('unable to load markups: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    saveProductMarkup: function () {
      // update markup qty
      if (this.wholesaleQtyIndex >= this.markups[0].markups.length) {
        window.alert('Please select wholesale level')
        return false
      }

      for (var i = 1; i < this.markups.length; i++) {
        for (var j = 0; j < this.markups[i].markups.length; j++) {
          // synchronise with qty from first column
          this.markups[i].markups[j].qty = this.markups[0].markups[j].qty
        }
      }

      // save markups
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + _this.productMarkupId, {
          name: _this.name,
          remarks: _this.remarks,
          currencyCode: _this.cboCurrencyCode,
          wholesaleQtyLevel: _this.markups[0].markups[_this.wholesaleQtyIndex].qty,
          markups: _this.markups
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              router.push('/markups')
            } else {
              window.alert(resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    openEditProductMarkupDialog: function (currentName) {
      this.txtProductMarkupNewName = currentName
      this.dialogEditProductMarkup = true
    },
    editProductMarkup: function (newName) {
      this.dialogEditProductMarkup = false
      this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + this.productMarkupId, {
        name: newName
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.name = newName
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    openDeleteProductMarkupDialog: function () {
      this.dialogDeleteProductMarkup = true
    },
    deleteProductMarkup: function () {
      this.dialogDeleteProductMarkup = false
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + this.productMarkupId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/markups')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    recountProductInRange: function () {
      var i

      // reset count for all range
      for (i = 0; i < this.markups.length; i++) {
        this.markups[i].productCount = 0
      }

      var previousRange
      for (var j = 0; j < this.products.length; j++) {
        for (var k = 0; k < this.products[j].skus.length; k++) {
          console.log('SKU: ' + this.products[j].skus[k].sku)
          previousRange = 0
          for (i = 0; i < this.markups.length; i++) {
            console.log('Range: ' + this.markups[i].maxCostPrice)
            console.log(this.products[j].skus[k].costPrice + '>' + previousRange + ' && ' + this.products[j].skus[k].costPrice + '<=' + this.markups[i].maxCostPrice)
            if (this.products[j].skus[k].costPrice > previousRange && this.products[j].skus[k].costPrice <= this.markups[i].maxCostPrice) {
              console.log('count++')
              this.markups[i].productCount++
              break
            }
            previousRange = this.markups[i].maxCostPrice
          }
        }
      }
    },

    openInsertRangeDialog: function () {
      this.dialogInsertRange = true
    },
    appendPriceRange: function () {
      // format qty range to inject
      var qtyRange = []
      for (var i = 0; i < this.markups[0].markups.length; i++) {
        qtyRange.push({
          qty: this.markups[0].markups[i].qty,
          markupPercentage: 0,
          minimumMarkupAmount: 0
        })
      }

      // inject new column
      this.markups.push({
        maxCostPrice: 999999999,
        productCount: 0,
        markups: qtyRange
      })
      this.markups[this.markups.length - 2].maxCostPrice = 0
      this.forceUpdate()
    },
    insertPriceRange: function (insertBefore) {
      var previousRangeIndex = 0
      var rangeIndex = null
      var i
      for (i = 0; i < this.markups.length; i++) {
        if (rangeIndex === null) {
          if (this.markups[i].maxCostPrice >= insertBefore) {
            rangeIndex = previousRangeIndex
          }
        }

        previousRangeIndex++
      }

      // format qty range to inject
      var qtyRange = []
      for (i = 0; i < this.markups[0].markups.length; i++) {
        qtyRange.push({
          qty: this.markups[0].markups[i].qty,
          markupPercentage: 0,
          minimumMarkupAmount: 0
        })
      }

      console.log(rangeIndex)
      if (rangeIndex === null) {
        window.alert('Unable to find price range')
      } else {
        // inject new column
        this.markups.splice(rangeIndex, 0, {
          maxCostPrice: 0,
          productCount: 0,
          markups: qtyRange
        })
        this.forceUpdate()
      }
    },
    removePriceRange: function (index) {
      this.markups.splice(index, 1)
      this.forceUpdate()
    },

    openInsertQtyDialog: function () {
      this.dialogInsertQty = true
    },
    appendQtyRange: function () {
      var lastQty = this.markups[0].markups[this.markups[0].markups.length - 1].qty
      for (var i = 0; i < this.markups.length; i++) {
        this.markups[i].markups.push({
          qty: parseInt(lastQty) + 2,
          markupPercentage: 0,
          minimumMarkupAmount: 0
        })
      }
      this.forceUpdate()
    },
    insertQtyRange: function (insertBefore) {
      var previousQtyIndex = 0
      var qtyIndex = null
      var i
      for (i = 0; i < this.markups[0].markups.length; i++) {
        if (qtyIndex === null) {
          if (this.markups[0].markups[i].qty >= insertBefore) {
            qtyIndex = previousQtyIndex
          }
        }
        previousQtyIndex++
      }

      if (qtyIndex === null) {
        window.alert('Unable to find qty range')
      } else {
        for (i = 0; i < this.markups.length; i++) {
          this.markups[i].markups.splice(qtyIndex, 0, {
            qty: 0,
            markupPercentage: 0,
            minimumMarkupAmount: 0
          })
        }
        this.dialogInsertQty = false
      }
    },
    removeQtyRange: function (index) {
      for (var i = 0; i < this.markups.length; i++) {
        this.markups[i].markups.splice(index, 1)
      }
      this.forceUpdate()
    }
  }
}
</script>
